import { DATA_SCOPES, FILTER_TYPE } from "../filterConstants"
import { DateFilter } from "../filterTypes/dateFilter"
import { NumberFilter } from "../filterTypes/numberFilter"
import { StringFilter } from "../filterTypes/stringFilter"

export class MetaAlgIdFilter extends NumberFilter {
  constructor(visibility, restrictedToScope) {
    super(
      "Alg ID",
      FILTER_TYPE.ALG_META.ID,
      [DATA_SCOPES.ALG_META],
      null,
      visibility,
      restrictedToScope,
    )
  }

  formatData(_device, _deviceGroups, _insight, _insightMetrics, _update, _alert, _user, alg_meta) {
    return alg_meta.alg_id
  }
}

export class MetaAlgNameFilter extends StringFilter {
  constructor(visibility, restrictedToScope) {
    super(
      "Alg Name",
      FILTER_TYPE.ALG_META.NAME,
      [DATA_SCOPES.ALG_META],
      null,
      visibility,
      restrictedToScope,
    )
  }

  formatData(_device, _deviceGroups, _insight, _insightMetrics, _update, _alert, _user, alg_meta) {
    return alg_meta.alg_name
  }
}

export class MetaFrameworkFilter extends StringFilter {
  constructor(visibility, restrictedToScope) {
    super(
      "Framework",
      FILTER_TYPE.ALG_META.FRAMEWORK,
      [DATA_SCOPES.ALG_META],
      null,
      visibility,
      restrictedToScope,
    )
  }

  formatData(_device, _deviceGroups, _insight, _insightMetrics, _update, _alert, _user, alg_meta) {
    return alg_meta.framework
  }
}

export class MetaBucketFilter extends StringFilter {
  constructor(visibility, restrictedToScope) {
    super(
      "Alg Bucket",
      FILTER_TYPE.ALG_META.BUCKET,
      [DATA_SCOPES.ALG_META],
      null,
      visibility,
      restrictedToScope,
    )
  }

  formatData(_device, _deviceGroups, _insight, _insightMetrics, _update, _alert, _user, alg_meta) {
    return alg_meta.alg_bucket
  }
}

export class MetaPathFilter extends StringFilter {
  constructor(visibility, restrictedToScope) {
    super(
      "Alg Path",
      FILTER_TYPE.ALG_META.PATH,
      [DATA_SCOPES.ALG_META],
      null,
      visibility,
      restrictedToScope,
    )
  }

  formatData(_device, _deviceGroups, _insight, _insightMetrics, _update, _alert, _user, alg_meta) {
    return alg_meta.alg_path
  }
}

export class MetaMd5ChecksumFilter extends StringFilter {
  constructor(visibility, restrictedToScope) {
    super(
      "MD5 Checksum",
      FILTER_TYPE.ALG_META.CHECKSUM,
      [DATA_SCOPES.ALG_META],
      null,
      visibility,
      restrictedToScope,
    )
  }

  formatData(_device, _deviceGroups, _insight, _insightMetrics, _update, _alert, _user, alg_meta) {
    return alg_meta.md5_checksum
  }
}

export class MetaCreatedDateFilter extends DateFilter {
  constructor(visibility, restrictedToScope) {
    super(
      "Date Created",
      FILTER_TYPE.ALG_META.DATE_CREATED,
      [DATA_SCOPES.ALG_META],
      null,
      visibility,
      restrictedToScope,
    )
  }

  formatData(_device, _deviceGroups, _insight, _insightMetrics, _update, _alert, _user, alg_meta) {
    return alg_meta.date_created
  }
}
